import { Navigate } from 'react-router';

import { ROUTES } from '@/config/routes';

import { useMobileTabs } from '../config/mobileTabs';

/** 모바일 첫 화면 = 허용된 첫 탭(specs/065 FR-008 — 축 분기 없이 기능 목록 순서로 정한다). */
export function MobileEntryRedirect() {
  const first = useMobileTabs()[0];
  return <Navigate to={first?.to ?? ROUTES.workspace.mobile.search} replace />;
}
